import { render, staticRenderFns } from "./AdvancedBottomNavigation.vue?vue&type=template&id=837d3596"
import script from "./AdvancedBottomNavigation.vue?vue&type=script&lang=js"
export * from "./AdvancedBottomNavigation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports